import { IH2OTheme, IItemStyles } from '@h2oai/ui-kit';

import { tagStyle } from '../../common/common.styles';

export const aiemTopStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '1rem',
};

export const aiemMenuStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  width: 'auto',
};

export const aiemTableStyle = (theme: IH2OTheme) => ({
  backgroundColor: theme.palette?.gray200,
  height: '100%',
  overflowY: 'hidden' as 'auto' | 'hidden' | 'scroll' | 'visible',
  overflowX: 'auto' as 'auto' | 'hidden' | 'scroll' | 'visible',
});

export const startedEventStyles = (theme: IH2OTheme): Partial<IItemStyles> => ({
  root: {
    ...tagStyle(theme),
    backgroundColor: theme.palette?.green100,
    color: theme.semanticColors?.categoryText,
  },
});

export const deletedEventStyles = (theme: IH2OTheme): Partial<IItemStyles> => ({
  root: {
    ...tagStyle(theme),
    backgroundColor: theme.palette?.red100,
    color: theme.semanticColors?.categoryText,
  },
});

export const pausedEventStyles = (theme: IH2OTheme): Partial<IItemStyles> => ({
  root: {
    ...tagStyle(theme),
    backgroundColor: theme.palette?.yellow200,
    color: theme.semanticColors?.categoryText,
  },
});
